module.exports = __webpack_public_path__ + "89e6a91f3015263df86c0ceb44657100.mp3";